import { memo } from 'react'
import { styled } from '@mui/material'
import { PlusIcon } from '$common/icons/plus.jsx'
import { JaryanLogoIcon } from '$common/icons'
import { showStaticWappsModal } from '$comp/modals/static-wapps'
import { useShouldShowFabButton } from '$logic/client-device'
import { FabButton } from '$logic/client-device/fab-buttons'
import { ChatListFab } from '$comp/_app/components/leftPanel/components/chat-list/components/shared/fab'
import { useIsChatListGoingDown } from '$comp/_app/components/leftPanel/components/chat-list/react-hooks'
import { clsx } from 'clsx'

const Fab = styled(ChatListFab)`
  position: absolute;
  bottom: 12px;
  width: 72px;
  height: 48px;
`

export const StaticWappsFab = memo(() => {
  const [shouldShowToolboxFab, shouldShowStaticWappsFab] =
    useShouldShowFabButton([FabButton.TOOLBOX, FabButton.STATIC_WAPPS])

  const isChatListGoingDown = useIsChatListGoingDown()

  if (!shouldShowStaticWappsFab) return null

  return (
    <Fab
      className={clsx({ hide: isChatListGoingDown })}
      sx={{
        left: shouldShowToolboxFab ? '68px' : '12px',
      }}
      color="secondary"
      variant="extended"
      onClick={showStaticWappsModal}
    >
      <JaryanLogoIcon sx={{ width: '32px', color: 'inherit' }} />
      <PlusIcon
        sx={{ color: 'inherit', width: '18px', height: '18px', mb: '5px' }}
      />
    </Fab>
  )
})
